import React from "react";
import Routes from "./routes";
import Header from "@/components/header";

if (process.env.REACT_APP_NODE_ENV === "production")
  console.log("App running in production mode");
else console.log("App running in development mode");

const App = () => {
  return (
    <div className="containers w-full overflow-hidden">
      <Header />
      <Routes />
    </div>
  );
};

export default App;
